import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import {
  submitSatisfaction,
  getSatisfactionQuestions
} from '../../redux/reducers/recovery';
import { compose } from 'redux';
// hoc
import { withFormik } from 'formik';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import Button from '../../components/Button/Button';
import Form from '../../components/Form/Form';
import RadioTable from '../Module/components/RadioTable';
import Preloader from '../../components/Preloader/Preloader';
// utils
import * as yup from 'yup';
import isEmpty from 'lodash.isempty';
import { toastResponseErrors } from '../../utils/response';
import { prepareMonthlyTable } from '../RecoveryPlan/utils';
// styles
import classnames from 'classnames/bind';
import styles from './MonthlyCheckIn.mod.css';
const cn = classnames.bind(styles);

class MonthlyCheckIn extends Component {
  componentDidMount() {
    this.props.getSatisfactionQuestions();
  }

  render() {
    const {
      isSubmitting,
      handleSubmit,
      satisfactionQuestions,
      values,
      errors,
      profile_color,
      setFieldValue,
      isLoading
    } = this.props;

    const userColor = profile_color || '#33C370';

    const tableData = !isEmpty(satisfactionQuestions)
      ? prepareMonthlyTable(satisfactionQuestions)
      : null;

    return (
      <PageWrapper centered>
        <h2>Life Satisfaction. Monthly check-in.</h2>
        <Preloader custom isActive={isLoading} />
        <Form className={cn('wrapper')} onSubmit={handleSubmit}>
          {tableData && (
            <div>
              <RadioTable
                className={cn('radio-table')}
                data={tableData}
                values={values}
                errors={errors}
                setFieldValue={setFieldValue}
              />
              <div className={cn('button-section')}>
                <Button
                  type="submit"
                  color={userColor}
                  disabled={isSubmitting || isLoading}
                  className="mr-30"
                >
                  Submit
                </Button>
              </div>
            </div>
          )}
        </Form>
      </PageWrapper>
    );
  }
}

const getValidationSchema = (data = {}) => {
  const { questions } = data;
  const schema = {};
  if (!questions) {
    return schema;
  }
  data.questions.forEach(
    ({ id, question }) =>
      (schema[id] = yup.string().required(`${question} is required!`))
  );
  return yup.object().shape(schema);
};

const enhance = compose(
  connect(
    state => ({
      isLoading: state.recovery.isLoading,
      satisfactionQuestions: state.recovery.satisfactionQuestions,
      relapse_risk: state.auth.user.progress,
      profile_color: state.auth.user.profile_color
    }),
    { submitSatisfaction, getSatisfactionQuestions }
  ),
  withFormik({
    mapPropsToValues: () => ({}),
    validateOnChange: false,
    validationSchema: ({ satisfactionQuestions }) =>
      getValidationSchema(satisfactionQuestions),
    handleSubmit: (
      values,
      {
        setSubmitting,
        setErrors,
        props: { closeModal, relapse_risk, submitSatisfaction, history }
      }
    ) => {
      const answers = Object.keys(values).map(id => ({
        question_id: id,
        answer_index: values[id]
      }));

      submitSatisfaction(answers)
        .then(() => {
          history.push('/dashboard');
        })
        .catch(response => {
          toastResponseErrors(response);
          setSubmitting(false);
        });
    },
    displayName: 'MonthlyCheckIn'
  })
);

export default enhance(MonthlyCheckIn);



// WEBPACK FOOTER //
// ./src/containers/MonthlyCheckIn/MonthlyCheckIn.jsx